import './App.css';
import React, { useState } from 'react';
import Stats from './stats';


function App() { //Maybe implement localstorage ?

  const [alert, setAlert] = useState('');
  const [count, setCount] = useState(1);

  const [input, setInput] = useState('');


  React.useEffect(() => {
    console.log("Number of sheep: " + count);
  }, [count]);

  let handleNumber = (number) => {
    setInput(x => x + number);
  }

  let handleEnter = (e) => {
    //console.log(e.key);
    if (e.key === 'Enter') handleSubmit();
  }

  let handleSubmit = () => {

    const sheep = document.getElementById("sheep");
    if (sheep.style.left !== 45 + "%" && sheep.style.left !== '') {
      setAlert("Sheep is still on its way! ");
    }


    else
      // eslint-disable-next-line
      if (input == count) {
        setCount(x => x + 1);
        setInput('');
        setAlert('');
        sheepChange();

      }
      else {
        setAlert("Wrong, look for a clue.");
        document.getElementById('count').classList.add('relative');
        showElement('count');

        setTimeout(()=>{
          hideElement('count')
          document.getElementById('count').classList.remove('relative');
        }, 6000);
      }

  }

  async function sheepChange() {
    const sheep = document.getElementById("sheep");
    sheep.src = "./SheepJump.png"

    let id = null;
    let pos = 45;
    clearInterval(id);
    id = setInterval(sheepOut, 10);
    function sheepOut() {
      if (pos === -15) {
        pos = 120;

      }
      else if (pos === 46) {
        sheep.style.left = (pos - 1) + "%";
        sheep.src = "./SheepStill.png"
        setAlert("Next"); //replace
        clearInterval(id);
      }
      else {
        pos--;
        sheep.style.left = pos + "%";
      }
    }
  }

  function showElement(id){
    document.getElementById(id).classList.remove('hidden');
  }
  function hideElement(id){
    document.getElementById(id).classList.add('hidden');
  }

  React.useEffect(()=>{
   setAlert('Start counting from number 1')
  },[]);

  return (
    <div className='h-screen w-screen bg-green-700'>
      <Stats count={count} />
      <div className='overflow-hidden relative bg-sky-800 text-white text-center text-xl font-bold h-2/5'>
        <figure id='count' className='hidden z-20 animate-pulse text-red-500 text-3xl' >{count}</figure>
        <img className="absolute top-2 right-16 md:right-32 lg:right-48 z-10" src='./moon.png' alt='cutemoon' ></img>
        <img id="sheep" className='transition-none absolute left-[45%] h-[50%] bottom-2' src='./SheepStill.png' alt="standing sheep" ></img>
      </div>

      <div className='bg-green-700 h-3/5 overflow-hidden'>
        <div className='relative flex justify-center'>
          <img className='peer h-16 w-full sm:w-1/2 lg:w-1/3' src="./Input.png" alt="bgimage"></img>
          <input onKeyDown={handleEnter}  className=' border-2 absolute bottom-2 h-12 w-[80%] sm:w-[40%] lg:w-[28%] text-3xl font-light bg-transparent border-transparent focus:border-transparent focus:ring-none focus:border-none focus:outline-none' placeholder='' onChange={e => setInput(e.target.value)} value={input} type="text" />
        </div>
        <div className='w-full h-full'>
          <div className="grid grid-cols-3 items-center w-full sm:w-3/4 md:w-1/2 lg:w-1/3 m-auto p-4 justify-items-center h-full pb-16">
            <img className='cursor-pointer' onClick={() => handleNumber(1)} src="./1.png" alt="number 1"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(2)} src="./2.png" alt="number 2"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(3)} src="./3.png" alt="number 3"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(4)} src="./4.png" alt="number 4"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(5)} src="./5.png" alt="number 5"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(6)} src="./6.png" alt="number 6"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(7)} src="./7.png" alt="number 7"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(8)} src="./8.png" alt="number 8"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(9)} src="./9.png" alt="number 9"></img>
            <img className='cursor-pointer' src="./backspace.png" onClick={() => { setInput(x => x.slice(0, -1)) }} alt="backspace"></img>
            <img className='cursor-pointer' onClick={() => handleNumber(0)} src="./0.png" alt="number 0"></img>
            <img className='cursor-pointer' src="./enter.png" onClick={handleSubmit} alt="enter button"></img>
          </div>
        </div>
      </div>

      <div id="alert" className="fixed top-8 left-2 lg:left-16 text-white text-xl font-black">{alert}</div>{/*placeholder for more robust solution*/}
    </div>
  );
}

export default App;
